import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { globalIV, globalSalt, errorCodeOtpValidationForLogin, mapOtpFaliureCodeToMessage } from '../../../config/constant';
import { AesUtil } from '../../../JS/AesUtil';
import { popupOpenClose, setLoadingMass, setPreloadScreen, setShowAutoLoginPopup, setRegPage, validateGuestdetail } from '../../../action/action';
import { fetchSessionToken } from '../../../JS/fetchSessionToken';
import { setGoHome, setLoader } from '../../action/homeAction';
import doorKeySvg from "../autoCheckin/assets/ico_generic_doorkey.svg";
import OTPInput from 'react-otp-input'
import OtpInputBox from '../utils/otpInputBox';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';


const AutoLoginPopup = (props) => {

    const [showGuestList, setShowGuestList] = useState(false)
    const [guestList, setGuestList] = useState([])
    const [selectedGuest, setSelectedGuest] = useState(undefined)
    const [showOtpInputPage, setShowOtpInputPage] = useState(false)
    const [accessCode, setAccessCode] = useState("")
    const [otpValidationErrorCode, setOtpValidationErrorCode] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [otpMessage, setOtpMessage] = useState("")
    const [validateOtpButtonClicked, setValidateOtpButtonClicked]= useState(false);
    const [resendOtpButtonClicked, setResendOtpButtonClicked]= useState(false)
    

    const { t } = props;
    let room = localStorage.getItem("room");
    let aesUtil = new AesUtil(128, 1000);
    const [loginProgress, setLoginProgress] = React.useState(false);
    const checkInguestInfo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") && JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));

    const handleLoginCallback = (status, room, locationId, errorMsg, response) => {
        setLoginProgress(false);
 
        setValidateOtpButtonClicked(false);
        setResendOtpButtonClicked(false);
        setErrorMsg("");
        
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})

        if (status) {
            props.setLoadingMass(true);
            props.setPreloadScreen(true);
            localStorage.setItem("room", room);
            sessionStorage.setItem("redirectInfo", JSON.stringify(props.redirectInfo))
            localStorage.setItem("autoLoggedIn", true);

            props.sendAnalytics(
                props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - success",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );

            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {

            props.sendAnalytics(
                props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - failed",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
            props.setLoader(false);
            if (response.data && response.data.payload && !response.data.payload.linkStatus && errorCodeOtpValidationForLogin.includes(response.data.payload.failureCode)) {

                if (response.status == 503) {
                    //For handling case like "Could not send otp , as no phone/email exist"
                    props.popupOpenClose(true, response.data.payload.failureReason);
                }
                else if (response.data.payload.failureCode == "OTP") {
                    // For handling case of "First time error has come so show otp form to user"
                    setShowOtpInputPage(true)
                    setOtpMessage(response.data.payload.failureReason)
                }
                else {
                    // For handling case of "either invalid otp, expire otp, mismatch", so just show error inside otp form only
                    setErrorMsg(mapOtpFaliureCodeToMessage[response.data.payload.failureCode])
                    setOtpValidationErrorCode(response.data.payload.failureCode)
                    if(response.data.payload.failureCode=="OTP_EXPIRED") {setTimeout(()=>{requestOTP();},3000)}
                }

                if (response.data.payload.failureReason) setOtpMessage(response.data.payload.failureReason);

            }
            else if (response.data && response.data.payload && !response.data.payload.linkStatus && response.data.payload.failureReason == "Multiple Guest") {
                let guestList = response.data.payload.guestList.map(item => {
                    if (item.id == null) {
                        item.id = "master";
                    }
                    return item;
                });

                setGuestList(guestList);
                setShowGuestList(true);
            }
            else {
                handleGoBack();
            }
        }
    }

    const handleAccompanyGuestSelectionBack = () => {
        handleGoBack();
    }

    const handleOTPScreenBack = () => {

        if(showGuestList){
            setShowOtpInputPage(false);
            setAccessCode("");
            setValidateOtpButtonClicked(false);
            setResendOtpButtonClicked(false);
            setErrorMsg("");
            setOtpValidationErrorCode("");
            return;
        }

        handleGoBack();
    }

    const handleGoBack = () => {
        localStorage.removeItem("room");
        props.setShowAutoLoginPopup(false);
        // props.popupOpenClose(true, t('login.auto_login_fail'));
    }

    const handleAutoLogin = (event, isOtpResendCase) => {
        event && event.preventDefault();

        if(props.externalSignIn && props.externalSignIn.memberId && window.device && window.device.platform != "Android"){
            let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo"));
            theKnowUserInfo.isRedirected = true;
            localStorage.setItem("theKnowUserInfo",JSON.stringify(theKnowUserInfo));
        }

        props.setLoader(true, "Connecting you to your room...", false)
        setLoginProgress(true);

        let encodData = fetchSessionToken();
        let loginGuestInfo = props.autoLoginData;

        let isAccompanyLogin = {};
        let otpValidationConfigs = {};

        if (props.accompanyGuestFlowEnabled && !loginGuestInfo.disableAccompanyGuestFlow) {
            if (selectedGuest == "master") {
                isAccompanyLogin = {
                    guestNotVerified: false
                }

                if (props.loginToRoomOtpRequiredFlag) {
                    otpValidationConfigs = {
                        requestForOtp: Boolean(!accessCode || isOtpResendCase ), 
                        // requestForOtpError: showOtpInputPage && ["OTP_MISMATCH", "OTP_EXPIRED"].includes(otpValidationErrorCode) ? true : undefined,
                        accessCode: accessCode,
                    }
                }
            } else {
                isAccompanyLogin = {
                    guestNotVerified: !selectedGuest ? true : false,
                    guestId: selectedGuest
                }

                otpValidationConfigs = {
                    requestForOtp: Boolean(!accessCode || isOtpResendCase ), 
                    accessCode: accessCode,
                }
            }
        } else {
            if (props.loginToRoomOtpRequiredFlag && !loginGuestInfo.disableOtpFlow) {
                otpValidationConfigs = {
                    requestForOtp: Boolean(!accessCode || isOtpResendCase ), 
                    // requestForOtpError: showOtpInputPage && ["OTP_MISMATCH", "OTP_EXPIRED"].includes(otpValidationErrorCode) ? true : undefined,
                    accessCode: isOtpResendCase ? "": accessCode,
                }
            }
        }

        setOtpValidationErrorCode("")
        props.validateGuestdetail(encodData, loginGuestInfo.lastName, loginGuestInfo.roomNumber, handleLoginCallback, loginGuestInfo.confirmationNumber, otpValidationConfigs, isAccompanyLogin);
    }

    const handleRadioChange = (guestId) => {
        setSelectedGuest(guestId)
    }

    const handleUserClick = () => {
        localStorage.removeItem("autoLoggedIn")
        props.setShowAutoLoginPopup(false);
    }

    const requestOTP = (event) => {
        setAccessCode("");
        setOtpValidationErrorCode("")
        handleAutoLogin(event, true)
    }

    React.useEffect(() => {
        if ((!room || room == "null") && !localStorage.getItem("autoLoggedIn")) {
            handleAutoLogin();
        }
    }, [])

    return (

        showOtpInputPage ? (
              <section class="overlay-custom" >
                    <div class="overlay-window-container-custom custom-popup" id="guestLoginOTP" >
                        <div class="overlay-window-custom" >
                            <div class="overlay-content padding-0">
                                <div class="overlay-header">
                                    <div class="overlay-header-title"  >
                                         <p>{t('autoLoginPopup.heading_otp_validation')}</p>          
                                    </div>
                                     <div class="close-button" onClick={() => handleOTPScreenBack()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M15 5L5 15M5 5L15 15" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    
                                </div>
                                
                                <div class="overlay-body-custom">
                                 <p class="heading" >{otpMessage}</p> 

                                 <OtpInputBox htmlId={"unique-otp-input"} value={accessCode} onChange={(value)=> setAccessCode(value)}  allowAutoFill={true} maxlength={props.loginToRoomOtpLength}/>

                                    {errorMsg && <div class="error-msg" style={{ color: "red" }}>{errorMsg}</div>}

                                    
                                </div>
                                <div class="overlay-controls-custom" >
                                       <p class="subHeading">{t('autoLoginPopup.didnt_receive_otp')}</p>
                                      <button class={`button  primary `} disabled={validateOtpButtonClicked} onClick={(event)=> { setValidateOtpButtonClicked(true); handleAutoLogin(event)}} > { validateOtpButtonClicked && <><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div></>} {t('autoLoginPopup.validate_otp')}</button>
                                      <button class="button secondary custom-popup-underline" disabled={resendOtpButtonClicked} onClick={(event)=>{ setResendOtpButtonClicked(true); setErrorMsg(t('autoLoginPopup.sending_new_otp_error_msg')); requestOTP(event)}}> Resend </button> 
                                    {/* onClick={props.customPopupConfigs.secondaryOnClick}>{props.customPopupConfigs.secondaryButtonText}</button>} */}
                                </div>
                            </div>
                        </div>
                </div>
                 
        </section>
            )
        :
        showGuestList ? (
            <section class="overlay">
                <div class="overlay-window-container">
                    <div className="overlay-window">
                        <div className="overlay-controls">
                            <div className="form-row margin-top-1 align-left">
                                <label>{t('login.guest_list')}</label>
                                <div className="radio-group">
                                    {guestList.map((guest, index) => (
                                        <div className="optgroup" key={index}>
                                            <input
                                                type="radio"
                                                name="companion"
                                                id={`companion-${guest.id}`}
                                                checked={selectedGuest === guest.id} // check if the guest is selected
                                                onChange={() => handleRadioChange(guest.id)}
                                            />
                                            <label htmlFor={`companion-${guest.id}`}>
                                                {guest.firstName} {guest.lastName}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button className="button w-100 margin-top-1 secondary"
                                onClick={handleAutoLogin}
                            >Proceed</button>
                            <button
                                className="button w-100 margin-top-1 secondary"
                                onClick={() => handleAccompanyGuestSelectionBack()}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        )
            : localStorage.getItem("autoLoggedIn") && (
                <>
                    <section class="overlay">
                        <div class="overlay-window-container">
                            <div class="overlay-window">
                                <div class="overlay-content padding-0">
                                    <div class="overlay-header">
                                        <div class="overlay-header-title w-65">
                                            <h2 style={{ color: "#000 !important;" }}>{t('login.auto_login_success_heading').replace("#GUESTNAME", checkInguestInfo[0].guestName).replace("FIRSTNAME", checkInguestInfo[0].guestProfile.firstName).replace("#LASTNAME", checkInguestInfo[0].guestProfile.lastName)}</h2>
                                            <p class="line_height-1_4">{t('login.auto_login_success_message').replace("#ROOMNUMBER", localStorage.getItem("room"))}</p>
                                            {localStorage.getItem("isDoorKeyInLayout") == "true" ? <p class="line_height-1_4">{t('check_in.digital_key_msg1')} <img src={doorKeySvg} style={{ width: "1.3rem", height: "1rem" }} alt='door_key' />{t('check_in.digital_key_msg2')}</p> /* Hide when hotel locks support virtual door key */ : <p>{t('check_in.key_from_desk')}</p>}
                                        </div>
                                        <div class="overlay-header-icon w-35">
                                            <i class="fas fa-check-circle"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    <button onClick={handleUserClick} class="button w-100">{loginProgress && <div class="loader-ring"></div>} Ok</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )
    )
}

const mapStateToProps = (state) => {
    return {
        redirectInfo: state.store2.redirectInfo,
        autoLoginData: state.store2.showAutoLoginPopup.autoLoginData,
        loginToRoomOtpRequiredFlag: state.store.home.clientConfig.loginToRoomOtpRequiredFlag,
        accompanyGuestFlowEnabled: state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.accompanyGuestFlowEnabled,
        loginToRoomOtpLength: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.loginToRoomOtpLength ,
        externalSignIn: state.store2.externalSignIn,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        guestDetail: state.store.home.guestDetails,
    }
}


export default connect(mapStateToProps, {
    setLoadingMass,
    setPreloadScreen,
    validateGuestdetail,
    popupOpenClose,
    setLoader,
    setShowAutoLoginPopup,
    setGoHome,
    setRegPage,
    sendAnalytics
})(withTranslation('translations')(AutoLoginPopup));